import { ToastRegion } from '@repo/design-system-kit/components/toast/provider/toast-region';
import type { QueryClient } from '@tanstack/react-query';
import type { ComponentProps } from 'react';
import { QueryClientProvider } from './client-provider';
import { IntlProvider } from './intl-provider';
import { UserProvider } from './user-provider';
import { SegmentProvider } from './segment-provider';

export function Providers({
  children,
  user,
  queryClient,
}: {
  children: React.ReactNode;
  user?: ComponentProps<typeof UserProvider>['user'];
  queryClient?: QueryClient;
}): React.ReactNode {
  return (
    <SegmentProvider>
      <QueryClientProvider queryClient={queryClient}>
        <UserProvider user={user}>
          <IntlProvider>
            {children}
            <ToastRegion />
          </IntlProvider>
        </UserProvider>
      </QueryClientProvider>
    </SegmentProvider>
  );
}
